{
  "form": {
    "input_placeholder": "ایک کام شامل کریں…",
    "parseWithAi_aria": "کام کو AI سے ترتیب دیں",
    "parseWithAi_title": "AI کے ساتھ صاف کریں اور ترجیح مقرر کریں",
    "priorityLabel_aria": "کام کی ترجیح",
    "add": "شامل کریں",
    "signInForAi": "AI خصوصیات استعمال کرنے کے لیے سائن اِن کریں۔",
    "aiUnavailable": "AI دستیاب نہیں۔ دوبارہ کوشش کریں۔",
    "saveTo": "محفوظ کریں",
    "saveTo_aria": "{{list}} میں محفوظ کریں",
    "saveToSynced_aria": "{{list}} میں محفوظ کریں، {{provider}}",
    "addedTo": "{{list}} میں شامل کر دیا گیا",
    "addedToSynced": "{{list}} میں شامل کر دیا گیا · {{provider}}",
    "show": "دکھائیں"
  },
  "priority": {
    "Critical": "نہایت اہم",
    "High": "زیادہ",
    "Medium": "درمیانی",
    "Low": "کم"
  },
  "item": {
    "edit_aria": "کام میں ترمیم کریں",
    "delete_aria": "کام حذف کریں",
    "addStep": "ایک قدم شامل کریں",
    "addStep_placeholder": "ایک قدم شامل کریں…",
    "addStep_aria": "{{task}} میں ایک قدم شامل کریں",
    "steps_group_aria": "{{task}} کے اقدام",
    "steps_progress_aria": "{{count}} میں سے {{done}} اقدام مکمل",
    "completeSteps_aria": "{{task}}۔ {{count}} کھلے اقدام بھی مکمل ہو جائیں گے"
  },
  "list": {
    "title": "کام",
    "newListFallback": "نئی فہرست",
    "completedMeta": "{{total}} میں سے {{completed}} مکمل",
    "deleteConfirm": "\"{{name}}\" حذف کریں؟",
    "rename_title": "نام بدلیں",
    "deleteList_title": "فہرست حذف کریں",
    "newListName_placeholder": "فہرست کا نام…",
    "newList": "نئی فہرست",
    "done": "ہو گیا",
    "emptyTitle": "ابھی کوئی کام نہیں",
    "emptySubtitle": "شروع کرنے کے لیے نیچے ایک شامل کریں۔",
    "noFilterMatch": "اس فلٹر سے کوئی کام مماثل نہیں۔",
    "createIn": "یہاں بنائیں",
    "inDestination": "{{destination}} میں",
    "createIn_aria": "{{destination}} میں بنائیں",
    "createInAccount_aria": "{{destination}} میں بنائیں، {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "{{destination}} میں بن رہی ہے…",
    "createFailed": "{{destination}} میں “{{name}}” نہیں بن سکی۔",
    "createLimit": "{{destination}} کی فہرستوں کی حد پوری ہو گئی ہے۔",
    "keepInRhemn": "Rhemn میں رکھیں"
  },
  "filter": {
    "label": "فلٹر",
    "all": "تمام"
  },
  "voice": {
    "mic_aria": "آواز سے کام شامل کریں",
    "mic_title": "اپنے کام بولیں — ترجیح اور وقت کے مطابق ترتیب دیے جائیں گے",
    "stop_aria": "روکیں اور کام ترتیب دیں",
    "recording": "ریکارڈنگ جاری ہے",
    "sorting": "آپ کے کام ترتیب دیے جا رہے ہیں…",
    "stripTitle": "سنے گئے کام",
    "stripCount": "{{checked}} از {{total}}",
    "discard": "مسترد کریں",
    "addN": "{{count}} شامل کریں",
    "addZero": "شامل کریں",
    "adding": "شامل کیا جا رہا ہے…",
    "parseFallback": "ترتیب نہیں دی جا سکی — آپ کے الفاظ خانے میں ہیں۔",
    "nothingHeard": "کچھ سنائی نہیں دیا — دوبارہ کوشش کریں۔",
    "micDenied": "مائیکروفون بند ہے — ترتیبات میں اجازت دیں۔",
    "gateBody": "اپنے کام بولیں — ترجیح اور نماز کے وقت کے مطابق۔ Pro کے ساتھ شامل۔",
    "listen_aria": "سن رہا ہے — اپنے کام بولیں"
  }
}
